import { MAX_RECENTLY_PLAYED_GAMES } from './/constants';
import {
    GameKind,
    RecentlyPlayedGame,
} from './types';

export function addGameToRecentlyPlayed(games: RecentlyPlayedGame[], game: RecentlyPlayedGame) {
    const index = games.findIndex((entry) => {
        return entry.id === game.id
        && entry.kind === game.kind;
    });
    if (index > -1) {
        games.splice(index, 1);
    }
    games.unshift(game);

    if (game.kind === GameKind.CasinoGeneric) {
        const numGenericGames = games.filter(({ kind }) => kind === GameKind.CasinoGeneric).length;
        // generic casino games are kept at 6 because they're the only ones present in the old design
        if (numGenericGames > MAX_RECENTLY_PLAYED_GAMES) {
            const lastGenericGameIndex = games.length
            - 1
            - [...games].reverse().findIndex(({ kind }) => kind === GameKind.CasinoGeneric);
            games.splice(lastGenericGameIndex, 1);
        }
    } else if (games.length > MAX_RECENTLY_PLAYED_GAMES) {
        games.pop();
    }
}
